import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3463" data-mp="129z1odrtp7i6">
      <Navbar data-id="element-3464" data-mp="xamefrx1hyf2" />
      <main data-id="element-3465" data-mp="xa4b6bbymjxn">
        <ConsularAffairs data-id="element-3466" data-mp="xae344gkf15z" />
      </main>
      <Footer data-id="element-3467" data-mp="xbfbu2a3zbkj" />
    </div>;
}